export default {
  ManagementFee: state => state.ManagementFee,
  OtherFees: state => state.OtherFees,
  Service12b1Fee: state => state.Service12b1Fee,
  UnderlyingFundsFee: state => state.UnderlyingFundsFee
};
